"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vasat_1 = require("vasat");
class AppBaseModel extends vasat_1.VasatModel {
    toJSON() {
        var res = super.toJSON();
        delete res["permissions"];
        delete res["type"];
        return res;
    }
}
class ACLModel extends vasat_1.VasatModel {
    set(a) {
        super.set(a);
        if (this.permissions) {
            this.canRead = !!this.permissions.find(p => p == 'api_read');
            this.canWrite = !!this.permissions.find(p => p == 'api_update');
            this.canDelete = !!this.permissions.find(p => p == 'api_delete');
        }
        return this;
    }
    toJSON() {
        let o = super.toJSON();
        let res = {};
        Object.keys(o).filter(k => k != 'canRead' && k != 'canWrite').forEach(k => res[k] = o[k]);
        delete o.permissions;
        delete o.canDelete;
        delete o.canRead;
        delete o.canWrite;
        return res;
    }
}
exports.ACLModel = ACLModel;
class ObjectMeta extends ACLModel {
    constructor(V, r) {
        super(V, 'ObjectMeta', r);
        this.account_acl = {};
        this.acl = [];
    }
    set(a) {
        super.set(a);
        var self = this;
        var reg = this.vasat.registeredClassForString(self.uid);
        if (!reg) {
            var self = this;
            reg = class StubImpl extends vasat_1.VasatModel {
                constructor() {
                    super(self.vasat, self.uid);
                }
                className() {
                    return self.uid;
                }
            };
            this.vasat.registerClass(reg);
        }
        this.stubClazz = reg;
        return this;
    }
    toJSON() {
        let o = super.toJSON();
        delete o.account_acl;
        delete o.acl_createSqns;
        delete o.acl_searchSqns;
        delete o.acl;
        delete o.selected;
        delete o.canDelete;
        delete o.permissions;
        delete o.type;
        return o;
    }
}
exports.ObjectMeta = ObjectMeta;
